import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
const BENEFITS = ['6 tomos completos para planificar tus clases', '5 bonos exclusivos incluidos', 'Acceso digital de por vida', 'Actualizaciones gratuitas', 'Garantía de 7 días sin preguntas'];
export function Pricing() {
  const {
    isExpired
  } = useLaunchCountdown();
  const megapack = PRICING_OPTIONS[0];
  if (!megapack) return null;
  return <section className="w-full px-5 py-12 sm:py-16" aria-labelledby="pricing-title" data-id="element-156" data-mp="3ct5c07n9imc">
      <div className="mx-auto max-w-xl" data-id="element-157" data-mp="204jmhlw5qrvc">
        <Reveal className="text-center" data-id="element-158" data-mp="205uyua3o57y2">
          <SectionBadge tone="dark" data-id="element-159" data-mp="206wcmmc2k8jh">
            {isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}
          </SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-2xl leading-tight text-snow outline-none sm:text-4xl" data-id="element-160" data-mp="1bb9t52ed47gw">
            Tu <span className="u-lime" data-id="element-161" data-mp="11knlbucw0l8r">Megapack</span> listo para usar
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-162" data-mp="xjlm3diz096s">
          <article className="rounded-3xl border-2 border-lime bg-rose-deep p-6 shadow-[0_22px_50px_rgba(0,0,0,0.4)] sm:p-8" data-id="element-163" data-mp="xkwqnfk8pkyy">
            <header className="text-center" data-id="element-164" data-mp="1u78en0cxb7ey">
              <h3 className="font-display text-xl text-snow sm:text-2xl" data-id="element-165" data-mp="1pa9hsa1vkmd2">{megapack.name}</h3>
              <p className="mt-1.5 text-sm font-extrabold uppercase tracking-wide text-lime" data-id="element-166" data-mp="1l84v5v9ugpzx">
                {megapack.description}
              </p>

              {!isExpired && <p className="mt-5 text-sm font-semibold text-snow-muted line-through" data-id="element-167" data-mp="9thfqyeedvc3">
                  {PRICING.totalValueOld} {PRICING.currency}
                </p>}
              <p className={`font-display text-5xl leading-none text-snow sm:text-6xl ${isExpired ? 'mt-5' : 'mt-1'}`} data-id="element-168" data-mp="6btrtewhrj8u">
                {megapack.price}{' '}
                <span className="font-sans text-base font-bold text-snow-muted" data-id="element-169" data-mp="baejur1lawm7">{PRICING.currency}</span>
              </p>
              {!isExpired && <p className="mt-2 text-sm font-extrabold text-lime" data-id="element-170" data-mp="1c7g59wbab25">Ahorrás {PRICING.savings} {PRICING.currency}</p>}
              <p className="mt-2 text-sm font-bold text-snow" data-id="element-171" data-mp="3jpy81bneloue">
                {isExpired ? 'Precio actualizado · un solo pago' : 'Un solo pago, sin suscripciones'}
              </p>
            </header>

            <ul className="mt-6 space-y-3 border-t border-snow/25 pt-6" aria-label={`Incluye ${megapack.name}`} data-id="element-172" data-mp="39tva6hzl4cd9">
              {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm font-medium leading-snug text-snow sm:text-base" data-id="element-173" data-mp="30s3zeyq6tfcj">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-174" data-mp="35px7xyeyqlfz" />
                  {benefit}
                </li>)}
            </ul>

            <CtaButton variant="lime" className="mt-7 w-full" href={megapack.checkoutUrl} data-id="element-175" data-mp="2h6ltfof2gbfh">
              Quiero mi Megapack ahora <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="2v6wf8d1iqzts" />
            </CtaButton>

            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-snow-muted" data-id="element-177" data-mp="2r36vc0vsh6f3">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-178" data-mp="352q2aqcv6bpt" />
              Pago seguro · Acceso inmediato por email
            </p>
          </article>
        </Reveal>
      </div>
    </section>;
}